var _style, _path, _path2, _path3, _ellipse, _ellipse2, _path4, _ellipse3, _ellipse4, _path5, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path6, _path7, _ellipse9, _path8, _path9, _path10, _ellipse10, _path11, _ellipse11, _ellipse12, _path12, _ellipse13, _ellipse14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,213.66c-6.77,0-13.55-2.66-18.72-7.99L57.75,96.57c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0L201.07,167.1c10.34,10.65,10.34,27.92,0,38.58C195.9,211,189.13,213.66,182.35,213.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.24,650.09c-6.77,0-13.55-2.66-18.72-7.99L57.75,423.89c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0l211.76,218.22c10.34,10.65,10.34,27.92,0,38.58C301.78,647.43,295.01,650.09,288.24,650.09z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.47,
    cy: 513.71,
    rx: 26.47,
    ry: 27.28
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.47,
    cy: 622.81,
    rx: 26.47,
    ry: 27.28
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,868.3c-6.77,0-13.55-2.66-18.72-7.99L57.75,751.21c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0l105.88,109.11c10.34,10.65,10.34,27.92,0,38.58C195.9,865.64,189.13,868.3,182.35,868.3z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.4,
    cy: 922.72,
    rx: 26.47,
    ry: 27.28
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.35,
    cy: 404.6,
    rx: 26.47,
    ry: 27.28
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M711.76,650.09c-6.77,0-13.55-2.66-18.72-7.99L269.52,205.67c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0l423.53,436.43c10.34,10.65,10.34,27.92,0,38.58C725.31,647.43,718.54,650.09,711.76,650.09z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.24,
    cy: 404.6,
    rx: 26.47,
    ry: 27.28
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.24,
    cy: 731.92,
    rx: 26.47,
    ry: 27.28
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.12,
    cy: 404.6,
    rx: 26.47,
    ry: 27.28
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.12,
    cy: 909.4,
    rx: 26.47,
    ry: 27.28
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M605.88,213.66c-6.77,0-13.55-2.66-18.72-7.99L481.28,96.57c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0L624.6,167.1c10.34,10.65,10.34,27.92,0,38.58C619.43,211,612.66,213.66,605.88,213.66z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M605.88,431.88c-6.77,0-13.55-2.66-18.72-7.99L481.28,314.78c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0L624.6,385.31c10.34,10.65,10.34,27.92,0,38.58C619.43,429.21,612.66,431.88,605.88,431.88z"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 731.92,
    rx: 26.47,
    ry: 27.28
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M566.35,936.68c-6.77,0-13.55-2.66-18.72-7.99l-66.35-68.38c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0l66.35,68.38c10.34,10.65,10.34,27.92,0,38.58C579.9,934.02,573.13,936.68,566.35,936.68z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M817.65,322.77c-6.77,0-13.55-2.66-18.72-7.99L587.16,96.57c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0L836.37,276.2c10.34,10.65,10.34,27.92,0,38.58C831.2,320.1,824.42,322.77,817.65,322.77z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M817.65,868.3c-6.77,0-13.55-2.66-18.72-7.99L587.16,642.1c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0l211.77,218.21c10.34,10.65,10.34,27.92,0,38.58C831.2,865.64,824.42,868.3,817.65,868.3z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 711.76,
    cy: 77.28,
    rx: 26.47,
    ry: 27.28
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M711.76,902.49c-6.77,0-13.55-2.66-18.72-7.99l-66.35-68.38c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0l66.35,68.38c10.34,10.65,10.34,27.92,0,38.58C725.31,899.83,718.54,902.49,711.76,902.49z"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 817.65,
    cy: 77.28,
    rx: 26.47,
    ry: 27.28
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 817.65,
    cy: 513.71,
    rx: 26.47,
    ry: 27.28
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M923.53,759.2c-6.77,0-13.55-2.66-18.72-7.99L798.93,642.1c-10.34-10.65-10.34-27.92,0-38.58 c10.34-10.65,27.1-10.65,37.44,0l105.88,109.11c10.34,10.65,10.34,27.92,0,38.58C937.08,756.53,930.3,759.2,923.53,759.2z"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 923.53,
    cy: 77.28,
    rx: 26.47,
    ry: 27.28
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 923.53,
    cy: 513.71,
    rx: 26.47,
    ry: 27.28
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP7);
export default __webpack_public_path__ + "static/media/P7.39169320e64bcd0c010d5f7fd361d0f8.svg";
export { ForwardRef as ReactComponent };